import {useCallback, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../store/store';
import {Status} from '../../enums/status';
import {requestEmailLink} from '../../store/slices/auth_with_email_slice';
import {Main} from '../../components/main/main.tsx';
import {Hero} from '../../components/hero/hero.tsx';
import {Page} from '../../components/page/page.tsx';
import {Card} from '../../components/card/card.tsx';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {__} from '../../support/lang/translations.ts';
import {Spacer} from '../../components/utility/spacer.tsx';
import formStyles from '../../components/form/form.module.scss';
import {Button} from '../../components/button/button.tsx';
import {FlexColumn} from '../../components/utility/flex_column.tsx';

export function LoginWithEmail() {
    const dispatch = useAppDispatch();
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);

    const [email, setEmail] = useState('');
    const emailIsValid =
        email.length > 5 &&
        email.includes('@') &&
        email.includes('.') &&
        email.indexOf('@') < email.lastIndexOf('.') &&
        email.lastIndexOf('.') < email.length - 1;

    const authState = useAppSelector((state) => state.authWithEmail);

    const onSubmit = useCallback(
        async (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            if (emailIsValid && e.target instanceof HTMLFormElement) {
                //todo validate email?
                dispatch(requestEmailLink(email.toString()));
            }
        },
        [email, emailIsValid, dispatch],
    );

    return (
        <Main>
            <Hero
                url={appConfig?.loginscreen}
                urls={[appConfig?.sliderphoto1, appConfig?.sliderphoto2, appConfig?.sliderphoto3]}
            />
            <Page>
                <Card style={{width: '100%', maxWidth: 400, marginTop: '-4rem', zIndex: 998}}>
                    <FlexRow alignment={Alignment.Center}>
                        <h2 style={{textAlign: 'center'}}>{__('login.titles.email')}</h2>
                    </FlexRow>
                    <Spacer style={{height: '3rem'}} />
                    {authState.status === Status.FULFILLED ? (
                        <FlexColumn alignment={Alignment.Center}>
                            <FlexRow alignment={Alignment.Center}>
                                <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                                    {__('login.copy.check_email')}
                                </div>
                            </FlexRow>
                            <FlexRow alignment={Alignment.Center}>
                                <Button to={'/'}>
                                    <i className={'fa-light fa-home'} />
                                    <span>{__('login.buttons.email_back')}</span>
                                </Button>
                            </FlexRow>
                        </FlexColumn>
                    ) : (
                        <form onSubmit={onSubmit}>
                            <div className={formStyles.form}>
                                <div className={formStyles.form__grid}>
                                    <div className={formStyles.grid__custom}>
                                        <fieldset>
                                            <legend data-grid-column-start={1} data-grid-column-end={13}>
                                                {__('login.fields.email')}
                                            </legend>
                                            <input
                                                type="text"
                                                name="email"
                                                value={email}
                                                placeholder="E-mail"
                                                data-grid-column-start={1}
                                                data-grid-column-end={13}
                                                onChange={(e) => setEmail(e.target.value)}
                                            ></input>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <FlexRow alignment={Alignment.Center}>
                                <Button
                                    type="submit"
                                    disabled={!emailIsValid || authState.status === Status.PENDING}
                                    loading={authState.status === Status.PENDING}
                                >
                                    <i
                                        className={
                                            authState.status === Status.PENDING
                                                ? 'fa-light fa-refresh'
                                                : 'fa-light fa-paper-plane'
                                        }
                                    />
                                    <span>{__('login.buttons.email_link')}</span>
                                </Button>
                            </FlexRow>
                        </form>
                    )}
                </Card>
            </Page>
        </Main>
    );
}
